import { Text } from '@lego/klik-ui';

type Props = {
  title: string;
  tagLevel: 'h1' | 'h2' | 'h3' | 'h4';
  weight?: 'bold' | 'semibold' | 'medium' | 'normal';
  [key: string]: unknown;
};

export const TextHeader = (props: Props) => {
  const { title, tagLevel, weight = 'medium', ...rest } = props;

  return (
    <Text as={tagLevel} fontWeight={weight} isTruncated textStyle={tagLevel} {...rest}>
      {title}
    </Text>
  );
};
